import { render, staticRenderFns } from "./ProjectListStatistic.vue?vue&type=template&id=001bf52c&"
import script from "./ProjectListStatistic.vue?vue&type=script&lang=js&"
export * from "./ProjectListStatistic.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListStatistic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports